import React from 'react';
import Header from './Header';
import Footer from './Footer';
import QuickActionPanel from './QuickActionPanel';

const PageLayout = ({ 
  children, 
  showHeader = true, 
  showFooter = true, 
  showQuickActions = true,
  className = "",
  containerClassName = ""
}) => {
  return (
    <div className="min-h-screen bg-background">
      {showHeader && <Header />}
      
      {/* Main content with consistent top padding to accommodate fixed header */}
      <main className={`pt-32 lg:pt-36 ${className}`}>
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-10 ${containerClassName}`}>
          {children}
        </div>
      </main>
      
      {/* Quick Action Panel for mobile */}
      {showQuickActions && (
        <QuickActionPanel className="fixed bottom-6 right-6 z-50 lg:hidden" />
      )}
      
      {/* Footer */}
      {showFooter && <Footer />}
    </div>
  );
};

export default PageLayout;